import { render, staticRenderFns } from "./warehouseSummary.vue?vue&type=template&id=a7ce48b4&"
import script from "./warehouseSummary.vue?vue&type=script&lang=js&"
export * from "./warehouseSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports